import { Box, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

type LoadingProps = {
  isLoading: boolean;
  text?: string;
};
export default function Loading({ isLoading, text }: LoadingProps) {
  return (
    <div>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <Box textAlign="center">
          <CircularProgress color="inherit" />
          <Typography variant="h6" component="div" sx={{ mt: 2 }}>
            {text}
          </Typography>
        </Box>
      </Backdrop>
    </div>
  );
}
